import type {
  IDownloadedFileResponseModel,
  IProcessDetailResponse,
  IProcessDetailViewModel,
} from "@models/index";
import { buildProcessDetailViewModel, HttpClient } from "@utils/index";

const BASE_URL = import.meta.env.VITE_EXTRACTION_API_BASE_URL;

if (!BASE_URL) {
  throw new Error(
    "Missing required environment variable: VITE_EXTRACTION_API_BASE_URL. " +
      "Please check your .env file and ensure the Intelligence Engine API URL is set.",
  );
}

class IntelligenceEngineApi {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient(`${BASE_URL}`);
  }

  public async getProcessDetailWithItems(
    processId: string,
  ): Promise<IProcessDetailViewModel> {
    const endpoint = `/processes/${processId}`;
    const response =
      await this.httpClient.makeAuthenticatedRequest<IProcessDetailResponse>(
        endpoint,
        {
          method: "GET",
        },
      );
    return buildProcessDetailViewModel(response);
  }

  public async downloadItemInputFile(
    processId: string,
    itemId: string,
  ): Promise<IDownloadedFileResponseModel> {
    return this.httpClient.makeAuthenticatedRequest<IDownloadedFileResponseModel>(
      `/processes/${processId}/items/${itemId}/input-file`,
      { method: "POST" },
    );
  }

  public async downloadAllInputFiles(
    processId: string,
  ): Promise<IDownloadedFileResponseModel> {
    return this.httpClient.makeAuthenticatedRequest<IDownloadedFileResponseModel>(
      `/processes/${processId}/input-files/archive`,
      { method: "POST" },
    );
  }
}

export { IntelligenceEngineApi };

export const intelligenceEngineApi = new IntelligenceEngineApi();
